// "ESTA MENSAGEM PODE RECEBER REAÇÃO?" — uma regra só, pura (14/10/2026).
//
// Victor: "saiu a opção de reagir à mensagem". O botão só existia para caixa
// Evolution/Waha; a caixa do WhatsApp da A&T é da WAME (API oficial) desde
// 11/10. Cada provedor precisa do id da mensagem NO WhatsApp:
//   - Waha: qualquer source_id;
//   - Evolution: só "WAID:..." (mensagem importada do Digisac não tem o id real);
//   - WAME (oficial): só "wamid...." e de até 30 dias (regra da Meta: reação a
//     mensagem mais velha não é entregue).
import { MESSAGE_TYPES } from 'dashboard/components-next/message/constants';

const TRINTA_DIAS = 30 * 24 * 60 * 60;

export const podeReagir = ({
  inbox,
  sourceId,
  messageType,
  deleted,
  createdAt,
  agora = Math.floor(Date.now() / 1000),
}) => {
  if (!sourceId || deleted || messageType === MESSAGE_TYPES.ACTIVITY) {
    return false;
  }
  if (inbox?.is_waha) return true;
  if (inbox?.is_evolution) return /^WAID:/.test(sourceId);
  if (inbox?.is_wame) {
    const recente = !createdAt || agora - createdAt <= TRINTA_DIAS;
    return sourceId.startsWith('wamid.') && recente;
  }
  return false;
};
